const comunicadosmicrositios = {
    ObtenerComunicadosMicrositios:"SICPO/Micrositio/ObtenerComunicados",
    CambiarEstadoComunicadosMicrositios:"SICPO/ComunicadosMicrositios/CambiarEstadoComunicadoMicrositio",
    CambiarOrdenComunicadosMicrositios:"SICPO/ComunicadosMicrositios/OrdenarComunicados",
    GuardarComunicadoMicrositio:"SICPO/ComunicadosMicrositios/GuardarComunicadoMicrositio",
    EditarComunicadoMicrositio:"SICPO/ComunicadosMicrositios/EditarComunicadoMicrositio"

}
export default comunicadosmicrositios;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/micrositioweb/comunicadosmicrositios/comunicadosmicrositios.js
// module id = null
// module chunks = 